import * as React from "react";
import { Select } from "antd";
import { useContext, useState, useEffect } from "react";
import { PbrSelect } from "src/components/common/PbrSelect/PbrSelect";
import { FormComponentProps } from "antd/lib/form";
import { ServiceContext } from "src/services/provider/Service.provider";
import { IFillSelect } from "src/services/interfaces/generic/IFillSelect";

interface ISelectCourtType {
  value: number;
  onChange: (id: number) => void;
  isTypeRequired: boolean;
}

export function SelectCourtType(props: ISelectCourtType & FormComponentProps) {
  const { courtTypeService } = useContext(ServiceContext);
  const [courtTypes, setCourtTypes] = useState<IFillSelect[]>([]);
  const Option = Select.Option;

  useEffect(() => {
    getCourtTypes()
  }, []);

  function getCourtTypes() {
    courtTypeService.getTypes().then(result => {
      if (result) {
        setCourtTypes(result);
      } else {
        setCourtTypes([]);
      }
    });
  }

  return (
    <PbrSelect
      name="ddlCourtType"
      size="large"
      formItemProps={{ label: "Tipo Precatório" }}
      formWrapper={props.form}
      showSearch
      value={props.value}
      placeholder="Selecione o Tipo"
      onChange={e => props.onChange(Number(e))}
      rules={[{ required: props.isTypeRequired, message: "Informe o Tipo do Precatório" }]}
    >
      {courtTypes?.map((e, i) => (
        <Option key={i.toString()} value={e?.id}>{`${e?.value}`}</Option>
      ))}
    </PbrSelect>
  );
}


// WEBPACK FOOTER //
// ./src/components/common/SelectCourtTypeCourtCorrectionType/SelectCourtType.tsx